// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"350":"72a30a16","443":"ad7f724d"}[chunkId] || chunkId) + "." + {"350":"db86e1188d2866f5","443":"9e91a769908d61ab","679":"f21c800eaae6defe","856":"7603a73515cf8126"}[chunkId] + ".js";
};